var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import { Grid, Divider } from '@mui/material';
import { FormikTextField } from '../../atoms/TextField';
import { FormikSelectField } from '../../atoms/SelectField';
import PageSubmitButton from '../../molecules/PageSubmitButton';
import { invoice as api } from '../../../api';
import { useNotify } from '../../../hooks/notificationHook';
import { useRequest } from '../../../hooks/requestHook';
import { camelize } from '../../../utils/camelize';
import { formatMoneyAmount } from '../../../utils/format';
import FormikDatePicker from '../../atoms/FormikDatePicker';
import FormikDateTimePicker from '../../atoms/FormikDateTimePicker';
import FormikSelectCountryCallingCodeField from '../../atoms/FormikSelectCountryCallingCodeField';
import LabeledGridItem from '../../atoms/LabeledGridItem';
import { useInvoiceListItem } from '../../../hooks/useListItem';
import OfferListLinks from '../../molecules/OfferListLinks';
var Form = styled.form(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 30px 0;\n\n  &.hide {\n    display: none;\n  }\n\n  .offer-lists a {\n    display: block;\n  }\n\n  .orders a {\n    display: block;\n  }\n\n  .old-order-ids {\n    color: #888;\n  }\n"], ["\n  margin: 30px 0;\n\n  &.hide {\n    display: none;\n  }\n\n  .offer-lists a {\n    display: block;\n  }\n\n  .orders a {\n    display: block;\n  }\n\n  .old-order-ids {\n    color: #888;\n  }\n"])));
var toFormikValue = function (invoice) {
    return {
        payment_method: invoice.paymentMethod,
        title: invoice.title,
        billing_name: invoice.billingName,
        store_name: invoice.storeName,
        person_name: invoice.personName,
        name_kana: invoice.nameKana,
        postal_code: invoice.postalCode,
        prefecture: invoice.prefecture,
        city: invoice.city,
        address: invoice.address,
        building: invoice.building,
        phone: invoice.phone,
        country_calling_code: invoice.countryCallingCode,
        email: invoice.email,
        created_date: invoice.createdDate,
        expired_date: invoice.expiredDate,
        tax_statement_created_date: invoice.taxStatementCreatedDate,
        paid_at: invoice.paidAt ? new Date(invoice.paidAt) : undefined,
        note: invoice.note || '',
        eori_number: invoice.eoriNumber,
    };
};
var REQUIRED_FIELDS = [
    'payment_method',
    'billing_name',
    'person_name',
    'postal_code',
    'prefecture',
    'city',
    'address',
    'phone',
    'country_calling_code',
    'email',
    'created_date',
    'expired_date',
];
var InvoiceForm = function (_a) {
    var invoice = _a.invoice, onChange = _a.onChange;
    var t = useTranslation().t;
    var notify = useNotify();
    var updateInvoice = useRequest(api.update);
    var paymentMethodItems = useInvoiceListItem().paymentMethodItems;
    var onSubmit = React.useCallback(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            (function () { return __awaiter(void 0, void 0, void 0, function () {
                var response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, updateInvoice({
                                id: invoice.id,
                                invoice: values,
                            })];
                        case 1:
                            response = _a.sent();
                            if (!response)
                                return [2 /*return*/];
                            onChange(response);
                            notify('success', [t('messages.updateSuccess')]);
                            return [2 /*return*/];
                    }
                });
            }); })();
            return [2 /*return*/];
        });
    }); }, [t, updateInvoice, invoice, notify, onChange]);
    var validate = React.useCallback(function (values) {
        var errors = {};
        REQUIRED_FIELDS.forEach(function (field) {
            if (!values[field] || values[field] === '') {
                errors[field] = t('errors.isRequired', {
                    field: t("params.invoice.".concat(camelize(field))),
                });
            }
        });
        return errors;
    }, [t]);
    var formik = useFormik({
        initialValues: toFormikValue(invoice),
        onSubmit: onSubmit,
        validate: validate,
        isInitialValid: true,
        validateOnMount: true,
        validateOnChange: true,
        enableReinitialize: true,
    });
    if (!invoice.roaster)
        return null;
    return (React.createElement(Form, { onSubmit: formik.handleSubmit },
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(LabeledGridItem, { label: t('params.offerList.name'), value: React.createElement(OfferListLinks, { pathPrefix: "/admin", offerLists: invoice.offerLists }) }),
            React.createElement(LabeledGridItem, { label: t('params.order.id'), value: React.createElement("div", { className: "orders" }, invoice.orders.map(function (order) { return (React.createElement(Link, { key: order.id, to: "/admin/orders/".concat(order.id) },
                    "#",
                    order.id)); })) }),
            React.createElement(LabeledGridItem, { label: t('params.roaster.name'), value: t('fullname', invoice.roaster) }),
            React.createElement(LabeledGridItem, { label: t('params.invoice.total'), value: formatMoneyAmount(invoice.total, invoice.currency) }),
            invoice.gmoPaymentOrderId && (React.createElement(LabeledGridItem, { label: t('params.invoice.gmoPaymentOrderId'), value: invoice.gmoPaymentOrderId })),
            invoice.paymentMethod !== 'bank_transfer' &&
                invoice.stripePaymentIntentUrl && (React.createElement(LabeledGridItem, { label: t('params.invoice.stripePaymentIntentUrl'), value: React.createElement("a", { href: invoice.stripePaymentIntentUrl, target: "_blank", rel: "noopener noreferrer" }, invoice.stripePaymentIntentUrl) })),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormikTextField, { fullWidth: true, name: "title", label: t('params.invoice.title'), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikSelectField, { fullWidth: true, name: "payment_method", label: t('params.invoice.paymentMethod'), items: paymentMethodItems, disabled: !invoice.isPaymentMethodUpdatable, required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "billing_name", label: t('params.order.billingName'), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "store_name", label: t('params.order.storeName'), formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "person_name", label: t('params.order.personName'), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "name_kana", label: t("params.order.nameKana"), formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(FormikTextField, { fullWidth: true, name: "postal_code", inputProps: { maxLength: 9 }, label: t('params.order.postalCode'), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(FormikTextField, { fullWidth: true, name: "prefecture", label: t("params.order.prefecture"), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(FormikTextField, { fullWidth: true, name: "city", label: t("params.order.city"), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(FormikTextField, { fullWidth: true, name: "address", label: t("params.order.address"), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "building", label: t('params.order.building'), formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 2 },
                React.createElement(FormikSelectCountryCallingCodeField, { name: "country_calling_code", required: true, label: t('params.order.countryCallingCode'), formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 4 },
                React.createElement(FormikTextField, { fullWidth: true, name: "phone", label: t('params.order.phone'), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "email", label: t('params.order.email'), required: true, formik: formik })),
            invoice.roaster.country.eoriNumberEnabled && (React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "eori_number", label: t('params.eoriNumber'), formik: formik }))),
            React.createElement(Divider, null),
            React.createElement(Grid, { item: true, xs: 12, sm: 4 },
                React.createElement(FormikDatePicker, { fullWidth: true, name: "created_date", label: t('params.invoice.createdDate'), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 4 },
                React.createElement(FormikDatePicker, { fullWidth: true, name: "expired_date", label: t('params.invoice.expiredDate'), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 4 },
                React.createElement(FormikDateTimePicker, { fullWidth: true, name: "paid_at", label: t('params.invoice.paidAt'), views: ['day', 'hours', 'minutes'], ampm: false, formik: formik })),
            invoice.roaster.country.code === 'KR' && (React.createElement(Grid, { item: true, xs: 12, sm: 4 },
                React.createElement(FormikDatePicker, { fullWidth: true, name: "tax_statement_created_date", label: t('params.invoice.taxStatementCreatedDate'), formik: formik }))),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormikTextField, { fullWidth: true, name: "note", label: t('params.invoice.note'), multiline: true, rows: 3, formik: formik }))),
        React.createElement(PageSubmitButton, { disabled: !formik.isValid }, t('buttons.update'))));
};
export default InvoiceForm;
var templateObject_1;
